export enum StorageEnum {
    Token = 'token',
    UserData = 'user-data',
    AccountDisabledMessage = 'account-disabled-message'
}